export default {
  namespaced: true,
  procedure_states: {
    scheduled: "Programado",
    in_progress: "En progreso",
    in_review: "En Revisión",
    reopened: "Reasignado",
    rejected: "Rechazado",
    approved: "Aprobado",
    cancelled: "Cancelado",
    canceled: "Cancelado",
    completed: "Completado",
    review: "En Revisión",
    value: {
      scheduled: "Programado",
      in_progress: "En progreso",
      in_review: "En Revisión",
      rejected: "Rechazado",
      approved: "Aprobado",
      cancelled: "Cancelado",
      canceled: "Cancelado",
      reassigned: "Reasignado",
      completed: "Completado",
      review: "En Revisión",
    },
  }
}
